import { render, staticRenderFns } from "./PostPreviewAnswers.vue?vue&type=template&id=bd4b2024&scoped=true"
import script from "./PostPreviewAnswers.vue?vue&type=script&lang=js"
export * from "./PostPreviewAnswers.vue?vue&type=script&lang=js"
import style0 from "./PostPreviewAnswers.vue?vue&type=style&index=0&id=bd4b2024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4b2024",
  null
  
)

export default component.exports